import AutoColumns from "@/components/AutoColumns"
import BasicForm from "@/components/form/BasicForm"
import BasicSelect from "@/components/form/BasicSelect"
import { useCoreData, useUser } from "@/stores/coreDataStore"
import { computed } from "vue"
import { defineComponent, proxyProp, Required, type ReactiveComponent } from "vue-utils"
import { useVtsFormButtons } from "./buttons"
import { useVtsFormContext } from "./context"
import VtsLogRemarks from "./VtsLogRemarks"

const VtsMainDetails: ReactiveComponent = () => {
	const context = useVtsFormContext()
	const buttons = useVtsFormButtons()
	const coreData = useCoreData()

	const logData = proxyProp(context, "logData")
	const canEdit = computed(() => context.canEdit)
	const editedBy = useUser(() => logData.editedBy.userId)

	const vtsCorrespondent = coreData.vtsCorrespondents.find((c) => c.name.toUpperCase() === "VTS")
	const otherCorrespondent = coreData.vtsCorrespondents.find((c) => c.name.toUpperCase() === "OTHER")

	const showFromOther = computed(() => logData.fromId === otherCorrespondent?.id)
	const showToOther = computed(() => logData.toId === otherCorrespondent?.id)

	if (logData.fromId === null!) logData.fromId = vtsCorrespondent?.id ?? null!
	if (logData.toId === null!) logData.toId = vtsCorrespondent?.id ?? null!

	return () => (
		<BasicForm buttons={buttons.value} style='display: block; margin-bottom: 1rem;'>
			<div class={`flex flex-col overflow-auto ${context.existingLog === null ? '' : 'flex-grow-1'}`} style={{ padding: "0.25rem" }}>
				<AutoColumns size="18rem" class="spacing-3">
					<label style={context.existingLog ? "" : "display: none;"}>
						Log Time (UTC)
						<input type="datetime-local" value={logData.logTime.toHTMLInputUTC()} disabled />
					</label>
					<label style={context.existingLog ? "" : "display: none;"}>
					Edited By
					<input type="text" value={editedBy.value?.fullName ?? "-"} disabled />
					</label>
					<label style={context.existingLog ? "" : "display: none;"}>
						Edited At (UTC)
						<input type="datetime-local" value={logData.editedBy.timeStamp.toHTMLInputUTC()} disabled />
					</label>
					<div class="form-col">
						<label>
							<Required label="From" />
							<BasicSelect
								options={coreData.vtsCorrespondents}
								value={logData.fromId}
								setValue={(correspondent) => (logData.fromId = correspondent.id)}
								defaultText={!canEdit.value ? "N/A" : "Select From"}
								disabled={!canEdit.value}
								required
							/>
						</label>
						{showFromOther.value && (
							<input
								type="text"
								v-model={logData.fromOther}
								placeholder={!canEdit.value ? "N/A" : "Enter From..."}
								disabled={!canEdit.value}
							/>
						)}
					</div>
					<div class="form-col">
						<label>
							<Required label="To" />
							<BasicSelect
								options={coreData.vtsCorrespondents}
								value={logData.toId}
								setValue={(correspondent) => (logData.toId = correspondent.id)}
								defaultText={!canEdit.value ? "N/A" : "Select To"}
								disabled={!canEdit.value}
								required
							/>
						</label>
						{showToOther.value && (
							<input
								type="text"
								v-model={logData.toOther}
								placeholder={!canEdit.value ? "N/A" : "Enter To..."}
								disabled={!canEdit.value}
							/>
						)}
					</div>
				</AutoColumns>
				<label class="flex mt-3 mb-2">
					<Required label="Remarks" />
				</label>
				<VtsLogRemarks
					value={logData.remarks}
					setValue={(remarks) => (logData.remarks = remarks)}
					canEdit={canEdit.value}
					required
				/>
			</div>
		</BasicForm>
	)
}

export default defineComponent(VtsMainDetails)
